export default {
  shared_track: function ({ sender }, locale) {
    if (locale === "fr") return `${sender} a partagé ton morceau.`
    else return `${sender} shared your track.`
  },
  files_are_available: function ({ band_name }, locale) {
    if (locale === "fr") return `${band_name} a partagé les fichiers demandés.`
    else return `${band_name} has shared the requested files with you.`
  },
  new_submission: function ({ sender }, locale) {
    if (locale === "fr") return `${sender} vous a envoyé un morceau.`
    else return `${sender} sent you a track.`
  },
  new_feedback: function ({ influencer_entity }, locale) {
    if (locale === "fr") return `${influencer_entity} a répondu a ton morceau.`
    else return ` ${influencer_entity} gave a feedback on your track.`
  },
  track_released_after_answer: function ({ track_name }, locale) {
    if (locale === "fr") return `${track_name} est sorti, tu peux le partager !`
    else return `${track_name} is out, share it now!`
  },
  some_files_are_already_available: function ({ band_name }, locale) {
    if (locale === "fr")
      return `${band_name} a partagé une partie des fichiers demandés.`
    else return `${band_name} has shared some of the files you asked for.`
  },
  track_files_are_needed: function ({ influencer_entity }, locale) {
    if (locale === "fr")
      return `Yeah ! ${influencer_entity} aime ton morceau et a besoin de fichiers supplémentaires pour le partager.`
    else
      return `Yeah ! ${influencer_entity} likes your track and needs to get additional files in order to share it properly.`
  },
  influencer_has_access_to_your_track_files: function (
    { influencer_entity },
    locale
  ) {
    if (locale === "fr")
      return `N'oublie pas ! ${influencer_entity} a besoin d'infos supplémentaires pour partager ton morceau.`
    else
      return `Don't forget ! ${influencer_entity} needs extra infos information in order to share your track.`
  },
  upload_your_files_reminder: function ({ influencer_entity }, locale) {
    if (locale === "fr")
      return `N'oublie pas ! ${influencer_entity} a besoin d'infos supplémentaires pour partager ton morceau.`
    else
      return `Don't forget ! ${influencer_entity} needs extra infos information in order to share your track.`
  },
  track_files_changed: function ({ band_name }, locale) {
    if (locale === "fr")
      return `${band_name} a mis à jour les fichiers demandés.`
    else return `${band_name} has updated his files.`
  },
  files_are_available: function ({ band_name }, locale) {
    if (locale === "fr")
      return `${band_name} t'a partagé les fichiers demandés.`
    else return `${band_name} has shared the requested files with you.`
  },
}
